module.exports = __webpack_public_path__ + "static/trees_static-d192374fbe4f5c8966b86269c4b449e5.png";